import { render, staticRenderFns } from "./BotonesMobile.vue?vue&type=template&id=ffc5c8ea"
import script from "./BotonesMobile.vue?vue&type=script&lang=js"
export * from "./BotonesMobile.vue?vue&type=script&lang=js"
import style0 from "./BotonesMobile.vue?vue&type=style&index=0&id=ffc5c8ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports